import React, {useState} from 'react';
import {Redirect} from 'react-router-dom'//yarn add @types/react-router-dom
import useStyles from './Styles';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Divider from '@mui/material/Divider';
import {Inc,Owner,RequestSearchCondition} from './Inc';
import Ajax from './Ajax';
import Loading from './Loading';
import RequestListSearch from './RequestListSearch';
import RequestListDetail from './RequestListDetail';
import RequestListItem from './RequestListItem';
import Title from './Title';
import AppBank from './AppBank';

interface RequestListProps {
	owner:Owner,
	bank:AppBank,
}
let p:number = 1;

const RequestList = (props:RequestListProps)=> {
    Ajax.setEditorId( props.owner.owner_id );
    const classes = useStyles();
    const [states,setStates] = useState({
        tabId:"p1",
        itemrequests:[],
        isLoading:true,
        pager:null,
        cond:Inc.defaultRequestSearchCondition(),
    });
    const search = (cond:RequestSearchCondition,first:boolean,newTabId?:string)=>{
        //console.log("search",cond);

        setStates({...states,itemrequests:[],"isLoading":true});
        let tabId = states.tabId;
        if( newTabId ){
            tabId = newTabId;
            p = 1;
        }
        if( first ){
            p = 1;
        }
        let path = "itemrequest/list";
        if( tabId==="p2" ){
            path = "itemrequest/item";
        }
        window.scrollTo(0,0);
        Ajax.search(path,cond,p,(res:any)=>{
            //console.log(res);
            if( res.ok ){
                setStates({...states,itemrequests:res.itemrequests,cond:cond,pager:res.pager,isLoading:false,tabId:tabId});
            } else {
                setStates({...states,"isLoading":false,tabId:tabId});
            }
        });
    }
    function changeTab(event: React.ChangeEvent<{}>, newValue: string) {
        //setStates({...states,tabId:newValue});
        search(states.cond,false,newValue);
    }

	const jump = (newPage:number)=>{
		//send(values,p);
		p = newPage;
		search(states.cond,false);
	}

	if( props.owner.owner_id===0 ){
		return <Redirect to="/profile"/>
	}
		
	return (
		<div id="fav_list" className={classes.root}>
            <Grid container spacing={2}>
                <Grid item xs={12} md={8} lg={9}>
                    <Paper className={classes.paper}>
                        <Title text="買いたい！" icon="bell"/>
                        <div style={{marginBottom:"2em"}}>
                        	完売したあなたの商品を「買いたい！」というお客さんの数が、ここに表示されます。<br/>
							まだ商品を購入していないお客さんだけが対象です。「買いたい！」のあとで実際に購入したお客さんは、ここの集計には含まれません。<br/>
                        </div>
                        <Tabs
                            value={states.tabId}
                            onChange={changeTab}
                            indicatorColor="primary"
                            textColor="primary"
                            variant="fullWidth"
                        >
                            <Tab style={{whiteSpace:"nowrap"}} value="p1" label="詳細表示"/>
                            <Tab style={{whiteSpace:"nowrap"}} value="p2" label="商品別集計" />
                        </Tabs>
                        <Divider style={{marginBottom:'1em'}}/>
                        {states.tabId==="p1" &&
                            <RequestListDetail list={states.itemrequests} owner={props.owner} pager={states.pager} jump={jump}/>
                        }
                        {states.tabId==="p2" &&
                            <RequestListItem list={states.itemrequests} owner={props.owner} pager={states.pager} jump={jump}/>
                        }
                    </Paper>
                </Grid>
                <Grid item xs={12} md={4} lg={3}>
                    <Paper className={classes.paper}>
                        <RequestListSearch update={search} bank={props.bank} bankKey={"savedRequestListItemSearchCondition"}/>
                    </Paper>
                </Grid>
            </Grid>

            <Loading isLoading={states.isLoading}/>
		</div>
	);
}

export default RequestList;
